import { put, call, takeLatest, select } from 'redux-saga/effects';

import forEach from 'lodash/forEach';

import { formatError } from '../../../libs';
import antifraudAPI from '../../api/antifraud';
import totemAPI from '../../api/totem';
import { Types, Creators } from '../../reducers/totem';
import { getUserDeviceInfo } from '../../utils/agent';
import getState from '../../utils/getState';

function* sendPayment() {
  try {
    const { totem, creditCard, app, location } = yield select(getState);
    const creditCards = creditCard.getIn(['creditCards']);
    const device = getUserDeviceInfo();
    const paymentOrder = {
      formaPagamento: { id: +totem.getIn(['order', 'formaPagamento']) },
      cartoes: [],
      infoAntifraude: {
        localizacao: location,
        dispositivo: `${device?.os?.name}${device?.browser?.name}`,
      },
    };

    const antifraud = yield call(antifraudAPI.getUsersIP);

    if (antifraud?.ip) {
      paymentOrder.infoAntifraude.ip = antifraud.ip;
    }

    const siteId = app.getIn(['config', 'siteId']);

    forEach(creditCards, function cb(item) {
      const titular = /\s$/.test(item.titular) ? item.titular.substring(0, item.titular.length - 1) : item.titular;
      const cc = {
        parcela: item.installment.parcelas.find((p) => p.numeroParcelas.toString() === item.parcela.toString()),
        valor: item.valor,
        numero: (item.numero.match(/\d+/g) || []).join(''),
        titular,
        seguranca: (item.seguranca.match(/\d+/g) || []).join(''),
        validade: item.validade,
        sequencia: item.id,
        filial: item.filial,
      };
      paymentOrder.cartoes.push(cc);
    });

    const confirmation = yield call(totemAPI.sendPaymentOrder, totem.getIn(['order', 'hash']), paymentOrder, siteId);

    if (confirmation && confirmation.errors && confirmation.errors.length) {
      throw confirmation.message;
    }

    yield put(Creators.sendTotemPaymentSuccess({ confirmPaymentOrder: { success: true, ...confirmation } }));
  } catch (error) {
    yield put(Creators.sendTotemPaymentError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SEND_TOTEM_PAYMENT_REQUEST, sendPayment);
}
